import { render, staticRenderFns } from "./WariWariDetail.vue?vue&type=template&id=197a92f1&"
import script from "./WariWariDetail.vue?vue&type=script&lang=js&"
export * from "./WariWariDetail.vue?vue&type=script&lang=js&"
import style0 from "./WariWariDetail.vue?vue&type=style&index=0&id=197a92f1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports